import { MedusaCart, MedusaProductVariant } from 'lib/home/generated/types/api';
import merge from 'lodash/merge';

export const updateVariantsInMedusaCart: (
  medusaCart: MedusaCart,
  updatedVariant: MedusaProductVariant
) => MedusaCart = (medusaCart, updatedVariant) => {
  medusaCart.items = medusaCart.items.map(item =>
    item.variant.id === updatedVariant.id ? { ...item, variant: { ...item.variant, ...updatedVariant } } : item
  );
  return medusaCart;
};

export const setProductVariantOnVariantList = (
  variants: MedusaProductVariant[],
  updatedVariant: MedusaProductVariant
) => variants.map(variant => (variant.id === updatedVariant.id ? merge(variant, updatedVariant) : variant));
